// import { Store } from "vuex";

const mutations = {
  IS_TOKEN (store, data) {
    store.isToken = data
  },
  IS_TEST_USER (state, res) {
    state.isTestUser = res
  },
  PATH_TEMPORAL (store, data) {
    store.pathTemporal = data
  },
  LOGIN_HELPER (store, data) {
    store.loginHelper = data
  }
}

export default mutations
